// 告警横幅状态（纯函数，便于测试）：同任务同级别只留一条；任务状态离开对应等待态时自动撤下
import type { AlertLevel } from "./types";

export interface Banner {
  id: string;
  level: AlertLevel;
  taskId: string;
  text: string;
  at: number;
}

/** 横幅级别 ↔ 任务状态 */
const LEVEL_STATUS: Partial<Record<AlertLevel, string>> = {
  scan: "waiting_scan",
  review: "review_required",
  blocked: "blocked",
};

export function bannerLevels(): AlertLevel[] {
  return ["scan", "review", "blocked", "failed"];
}

export function addBanner(list: Banner[], b: Banner): Banner[] {
  return [b, ...list.filter((x) => !(x.taskId === b.taskId && x.level === b.level))];
}

export function removeBanner(list: Banner[], id: string): Banner[] {
  return list.filter((b) => b.id !== id);
}

/** 收到任务状态事件：撤掉已不成立的横幅 */
export function onTaskStatus(list: Banner[], taskId: string, status: string): Banner[] {
  return list.filter((b) => {
    if (b.taskId !== taskId) return true;
    const want = LEVEL_STATUS[b.level];
    return want === undefined || want === status;
  });
}

/** 还需要响铃吗：有未处理的扫码/审核横幅 */
export function ringKind(list: Banner[]): "scan" | "review" | null {
  if (list.some((b) => b.level === "scan")) return "scan";
  if (list.some((b) => b.level === "review")) return "review";
  return null;
}
